export const apiConstants = {
  url: "/api/dashboard"
};
